import { motion } from "framer-motion";

const Preloader = () => {
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] bg-forest flex flex-col items-center justify-center"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
    >
      <motion.div
        initial={{ scale: 0.6, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="w-28 h-28 rounded-full bg-white shadow-2xl overflow-hidden"
      >
        <img
          src="/assets/nesha-logo.png"
          alt="Nesha Global Pvt Ltd logo"
          className="w-full h-full object-cover"
        />
      </motion.div>

      <div className="mt-8 overflow-hidden">
        <motion.p
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.7, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-2xl sm:text-3xl tracking-[0.35em] text-gold uppercase"
        >
          Nesha Global
        </motion.p>
      </div>

      <div className="mt-4 overflow-hidden">
        <motion.p
          initial={{ y: "120%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.7, delay: 0.55, ease: [0.22, 1, 0.36, 1] }}
          className="font-mono text-[10px] sm:text-xs tracking-[0.45em] text-cream/60 uppercase"
        >
          Where Vision Meets The World
        </motion.p>
      </div>

      <div className="absolute bottom-0 left-0 h-[3px] bg-sunset" style={{ width: "100%" }}>
        <motion.div
          className="h-full bg-sunset"
          initial={{ width: "0%" }}
          animate={{ width: "100%" }}
          transition={{ duration: 1.9, ease: "easeInOut" }}
        />
      </div>
    </motion.div>
  );
};

export default Preloader;
